import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../utils/common'
import Button from '../../Button'

import {
  QA_NAME_SELECTION_TOOLBAR_CONTENT,
  QA_NAME_SELECTION_TOOLBAR_CONTENT_SELECT_ALL,
  QA_NAME_SELECTION_TOOLBAR_CONTENT_SELECTED,
  QA_NAME_SELECTION_TOOLBAR_CONTENT_UNSELECT_ALL,
} from './SelectionToolbarContent.constants'

import * as styles from './SelectionToolbarContent.module.css'

function SelectionToolbarContent({
  allSelected,
  className = styles.SelectionToolbarContent,
  count,
  excludeCount,
  selectAllProps,
  selected,
  onClose,
  onSelectAll,
}) {
  const { t } = useTranslation()

  const qaPropsBox = getQaSelector({ value: QA_NAME_SELECTION_TOOLBAR_CONTENT })

  const qaPropsSelected = getQaSelector({
    value: QA_NAME_SELECTION_TOOLBAR_CONTENT_SELECTED,
  })

  function getCountContentText(title) {
    return t(title, {
      count: allSelected ? count - excludeCount : selected,
    })
  }

  return (
    <div {...qaPropsBox} className={className}>
      {allSelected && !excludeCount ? (
        <span {...qaPropsSelected}>
          {getCountContentText('Table.AllSelectedItemsCountKey')}
        </span>
      ) : (
        <>
          <span {...qaPropsSelected}>
            {getCountContentText('Table.SelectedItemsCountKey')}
          </span>
          {onSelectAll ? (
            <>
              <Button.Text
                {...selectAllProps}
                height={24}
                qaName={QA_NAME_SELECTION_TOOLBAR_CONTENT_SELECT_ALL}
                text={t('Table.SelectAllBtnKey', { count })}
                onClick={onSelectAll}
              />
              <span>{t('Table.ButtonJointKey')}</span>
            </>
          ) : null}
        </>
      )}
      <Button.Text
        height={24}
        qaName={QA_NAME_SELECTION_TOOLBAR_CONTENT_UNSELECT_ALL}
        text={t('Table.UnselectAllBtnKey')}
        onClick={onClose}
      />
    </div>
  )
}

export default SelectionToolbarContent
